module.exports = __webpack_public_path__ + "img/龙椅·正襟危坐.596c0603.png";